import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type FeaturesService from '../services/features.ts';
import {
  aiReadableFileAccept,
  aiReadableFileTypesDisplay,
} from '../utils/tuition-assistance/ai-validation.ts';

interface AiReadableFileTypesSignature {
  Args: { Positional: [kind: 'accept' | 'display'] };
  Return: string;
}

export default class AiReadableFileTypes extends Helper<AiReadableFileTypesSignature> {
  @service declare features: FeaturesService;

  /**
   * Resolves the picker constraint or its display label for the active environment.
   *
   * @param positional - Whether the caller needs the `accept` value or display text.
   * @returns The environment-specific file type string.
   */
  compute([kind]: AiReadableFileTypesSignature['Args']['Positional']): string {
    return kind === 'accept'
      ? aiReadableFileAccept(this.features.tioEnvironment)
      : aiReadableFileTypesDisplay(this.features.tioEnvironment);
  }
}
